var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchitecture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.69 56.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d7e8f0;\n        stroke: #d7e8f0;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 2px;\n      }\n\n      .cls-3, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #1d47b1;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.13,17.09c5.56-4.43,14.15-1.55,14.31,7.18,.16,8.73-6.19,11.67-9.79,12.21-10.4,1.57-9.9,9.57-18.4,10.07-5.49,.32-18,1.66-18-17.5,0-11.96,9-21.5,17.5-18.5,6.13,2.16,7.75,11.83,14.39,6.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.48,41.88h31.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.42,35.01v-15.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.28,20.11v14.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.49,21.36l14.46-6.56,14.19,6.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.66,16.76v18.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.04,16.23v18.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.69,38.45h25.31"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 56.69,
    height: 56.69
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitecture);
export default __webpack_public_path__ + "static/media/architecture.1a067106cd77cc617c8874d78df522dd.svg";
export { ForwardRef as ReactComponent };